import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { Skeleton } from '@clouway/ui'

import { LocaleForm, type LocaleFormValues } from '../components/LocaleForm'
import { useSettings, useUpdateSettings } from '../hooks'

export function LocaleSettings() {
  const { t } = useTranslation('feature')
  const { data: settings, isLoading } = useSettings()
  const { mutateAsync: update } = useUpdateSettings()

  if (isLoading || !settings) {
    return (
      <div className="mx-auto flex w-full max-w-2xl flex-col gap-4">
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
      </div>
    )
  }

  const onSubmit = async (values: LocaleFormValues) => {
    try {
      await update(values)
      toast.success(t('locale.saved'))
    } catch {
      toast.error(t('locale.saveFailed'))
    }
  }

  return <LocaleForm initialValues={settings} onSubmit={onSubmit} />
}
